export const WARNING = 'WARNING';
export const SESSION = 'SESSION';